export default {
    setTmcSelectedProcessingProject(state, project) {
        state.selectedTmcProcessingProject = project
    },
    setQueryData(state, queryData) {
        state.searchQueryData = queryData
    },
    setTmcSelectedVideoCalibration(state, calibrations) {
        state.selectedTmcVideoCalibrations = calibrations
    },
    selectTmcCalibration(state, calibration) {
        state.selectedTmcCalibration = calibration
    },
    setTmcSelectedProcessingDevice(state, processingDevice) {
        state.selectedTmcProcessingDevice = processingDevice
    },
    replaceTmcVideoCalibrations(state, videoCalibrations) {
        if (state.selectedTmcProcessingProject) {
            let deviceIndex = state.selectedTmcProcessingProject.devices.findIndex(device => state.selectedTmcProcessingDevice._id === device._id)
            if (deviceIndex !== -1) {
                state.selectedTmcProcessingProject.devices[deviceIndex].videoCalibrations = videoCalibrations
                if(videoCalibrations && videoCalibrations.length > 0 && videoCalibrations[0].directionLookup){
                    state.selectedTmcProcessingProject.devices[deviceIndex].directionLookup = videoCalibrations[0].directionLookup
                }
                state.selectedTmcProcessingDevice = state.selectedTmcProcessingProject.devices[deviceIndex]
                state.selectedTmcVideoCalibrations = state.selectedTmcProcessingProject.devices[deviceIndex].videoCalibrations
            }
        }
    },
    updateTmcDeviceTasks(state, deviceData) {
        if (state.selectedTmcProcessingProject) {
            let deviceIndex = state.selectedTmcProcessingProject.devices.findIndex(device => deviceData.dataDeviceId === device._id)
            if (deviceIndex !== -1) {
                state.selectedTmcProcessingProject.devices[deviceIndex].tasks = deviceData.tasks
            }
        }
    },
    updateTmcVehicleProcessingTasks(state, deviceData) {
        if (state.selectedTmcProcessingProject) {
            let deviceIndex = state.selectedTmcProcessingProject.devices.findIndex(device => deviceData.dataDeviceId === device._id)
            if (deviceIndex !== -1) {
                if(state.selectedTmcProcessingProject.devices[deviceIndex].initialValidationData){
                    state.selectedTmcProcessingProject.devices[deviceIndex].initialValidationData.fullTasks = deviceData.tasks
                }

            }
        }
    },
    updatePipelineOnDataDevice(state, dataDevice) {
        if (state.selectedTmcProcessingProject) {
            let deviceIndex = state.selectedTmcProcessingProject.devices.findIndex(device => dataDevice._id === device._id)
            if (deviceIndex !== -1) {
                console.log('On update pipeline mutation: ', dataDevice)
                state.selectedTmcProcessingProject.devices[deviceIndex].dataRequired = dataDevice.dataRequired
            }
        }
    },
    setDpLegendSelection(state, selection) {
        state.dpLegendSelection = selection
    },
    mergeTmcInitialValidationData(state, data){
        if (state.selectedTmcProcessingProject && data.devices && data.devices.length > 0) {
            let devices =JSON.parse(JSON.stringify(state.selectedTmcProcessingProject.devices))
            data.devices.forEach(deviceData => {
                let deviceIndex = devices.findIndex(device =>  device._id === deviceData._id)
                if (deviceIndex !== -1) {
                    devices[deviceIndex].initialValidationData = deviceData
                    devices[deviceIndex].refresh = false
                }
            })

            state.selectedTmcProcessingProject.devices = devices
            console.log("Merged devices: ", state.selectedTmcProcessingProject.devices)
        }
    },
    replaceTmcValidationData(state, data){
        if (state.selectedTmcProcessingProject && data && data._id) {
            let devices =JSON.parse(JSON.stringify(state.selectedTmcProcessingProject.devices))
            let deviceIndex = devices.findIndex(device =>  device._id === data._id)
            if (deviceIndex !== -1) {
                devices[deviceIndex].initialValidationData = data
            }

            state.selectedTmcProcessingProject.devices = devices
            console.log("Replaced devices: ", state.selectedTmcProcessingProject.devices)
        }
    },
    replaceTmcVideoPathData(state, data){
        if (state.selectedTmcProcessingProject && data && data._id) {
            let devices =JSON.parse(JSON.stringify(state.selectedTmcProcessingProject.devices))
            let deviceIndex = devices.findIndex(device =>  device._id === data._id)
            if (deviceIndex !== -1) {
                devices[deviceIndex].tasks = data.tasks
            }

            state.selectedTmcProcessingProject.devices = devices
            console.log("Replaced devices: ", state.selectedTmcProcessingProject.devices)
        }
    },

    replaceTmcVideoPathTasks(state, data){
        if (state.selectedTmcProcessingProject && state.selectedTmcProcessingProject.devices && state.selectedTmcProcessingProject.devices.length > 0) {
            let devices =JSON.parse(JSON.stringify(state.selectedTmcProcessingProject.devices))
            data.forEach(deviceData => {
                let deviceIndex = devices.findIndex(device =>  device._id === deviceData.dataDeviceId)
                if (deviceIndex !== -1) {
                    devices[deviceIndex].tasks = deviceData.tasks
                    devices[deviceIndex].videoPathRefresh = false
                }
            })

            state.selectedTmcProcessingProject.devices = devices
            console.log("Merged devices Video Path: ", state.selectedTmcProcessingProject.devices)
        }
    },
    replaceTmcLiveTasks(state, data){
        if (state.selectedTmcProcessingProject && state.selectedTmcProcessingProject.devices && state.selectedTmcProcessingProject.devices.length > 0 && data.devices) {
            let devices =JSON.parse(JSON.stringify(state.selectedTmcProcessingProject.devices))
            data.devices.forEach(deviceData => {
                let deviceIndex = devices.findIndex(device =>  device._id === deviceData._id)
                if (deviceIndex !== -1) {
                    devices[deviceIndex].liveProcessingDeviceData = deviceData
                    devices[deviceIndex].liveRefresh = false
                }
            })

            state.selectedTmcProcessingProject.devices = devices
            console.log("Merged devices refresh: ", state.selectedTmcProcessingProject.devices)
        }
    },

    setTmcRefreshForDataDevice(state, data){
        console.log('Find device for refresh: 1', data)
        if (state.selectedTmcProcessingProject && state.selectedTmcProcessingProject.devices && state.selectedTmcProcessingProject.devices.length > 0) {
            console.log('Find device for refresh: 2')
            let devices = JSON.parse(JSON.stringify(state.selectedTmcProcessingProject.devices))
            let deviceIndex = devices.findIndex(device => device._id === data.id)
            if (deviceIndex !== -1) {
                console.log('Find device for refresh: ', deviceIndex)
                devices[deviceIndex].refresh = data.refresh
            }

            state.selectedTmcProcessingProject.devices = devices
        }
    },

    setTmcRefreshForDataDeviceStepOne(state, data){
        console.log('Find device for refresh step one: 1', data)
        if (state.selectedTmcProcessingProject && state.selectedTmcProcessingProject.devices && state.selectedTmcProcessingProject.devices.length > 0) {
            console.log('Find device for refresh step one: 2')
            let devices = JSON.parse(JSON.stringify(state.selectedTmcProcessingProject.devices))
            let deviceIndex = devices.findIndex(device => device._id === data.id)
            if (deviceIndex !== -1) {
                console.log('Find device for refresh step one: ', deviceIndex)
                devices[deviceIndex].videoPathRefresh = data.refresh
            }

            state.selectedTmcProcessingProject.devices = devices
        }
    },

    setTmcRefreshingDevices(state, deviceRefresh){
        if (state.selectedTmcProcessingProject && state.selectedTmcProcessingProject.devices && state.selectedTmcProcessingProject.devices.length > 0) {
            let devices =JSON.parse(JSON.stringify(state.selectedTmcProcessingProject.devices))
            deviceRefresh.forEach(dr => {
                let deviceIndex = devices.findIndex(device =>  device._id === dr.id)
                if (deviceIndex !== -1) {
                    devices[deviceIndex].refresh = dr.refresh
                }
            })

            state.selectedTmcProcessingProject.devices = devices
        }
    },
    setTmcVideoPathRefreshingDevices(state, deviceRefresh){
        if (state.selectedTmcProcessingProject && state.selectedTmcProcessingProject.devices && state.selectedTmcProcessingProject.devices.length > 0) {
            let devices =JSON.parse(JSON.stringify(state.selectedTmcProcessingProject.devices))
            deviceRefresh.forEach(dr => {
                let deviceIndex = devices.findIndex(device =>  device._id === dr.id)
                if (deviceIndex !== -1) {
                    devices[deviceIndex].videoPathRefresh = dr.refresh
                }
            })

            state.selectedTmcProcessingProject.devices = devices
        }
    },
    setTmcLiveRefreshingDevices(state, deviceRefresh){
        if (state.selectedTmcProcessingProject && state.selectedTmcProcessingProject.devices && state.selectedTmcProcessingProject.devices.length > 0) {
            let devices =JSON.parse(JSON.stringify(state.selectedTmcProcessingProject.devices))
            deviceRefresh.forEach(dr => {
                let deviceIndex = devices.findIndex(device =>  device._id === dr.id)
                if (deviceIndex !== -1) {
                    devices[deviceIndex].liveRefresh = dr.refresh
                }
            })

            state.selectedTmcProcessingProject.devices = devices
        }
    },
    setTmcValidationData(state, data){
        if (state.selectedTmcProcessingProject && data && data._id) {
            let devices =JSON.parse(JSON.stringify(state.selectedTmcProcessingProject.devices))
            let deviceIndex = devices.findIndex(device =>  device._id === data._id)
            if (deviceIndex !== -1) {
                devices[deviceIndex].directionLookup = data.directionLookup
                devices[deviceIndex].validationData = data.validationData
            }

            console.log('On set validation data: ', devices[deviceIndex])
            state.selectedTmcProcessingProject.devices = devices
            state.selectedTmcProcessingDevice = devices[deviceIndex]
        }
    },
}
